interface StickyButtonProps {
  isVisible: boolean;
}

export default function StickyButton({ isVisible }: StickyButtonProps) {
  return (
    <a
      href="https://lin.ee/PJ9odjt"
      target="_blank"
      rel="noopener noreferrer"
      className={`md:hidden fixed bottom-6 right-6 w-14 h-14 bg-[#06C755] rounded-full flex items-center justify-center shadow-2xl transition-all duration-300 z-50 cursor-pointer ${
        isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-20 pointer-events-none'
      }`}
      style={{ boxShadow: '0 8px 24px rgba(6,199,85,0.5)' }}
    >
      <i className="ri-line-fill text-2xl text-white"></i>
    </a>
  );
}
